import { useContext, useEffect, useState } from 'react';
import {
  LocationInfo,
  LocationInfoType
} from 'record-it-utils/location/GeolocationManager/GeolocationManager';
import { GeolocationManagerContext } from '../../context/GeolocationManagerContext';

/**
 * @performance - This hook causes a rerender as soon as the effect is called. This can be optimized.
 */
export function useOptionalLocationInfo(): LocationInfo {
  const { manager } = useContext(GeolocationManagerContext);
  const [locationInfo, setLocationInfo] = useState<LocationInfo>({
    type: LocationInfoType.Pending
  });

  useEffect(() => {
    const disposable = manager.bindOptionalGeolocation((newLocationInfo) => {
      setLocationInfo(newLocationInfo);
    });

    return () => disposable.dispose();
  }, [manager]);

  return locationInfo;
}
